import { logError } from "../../../utils/error";
const EXTRACTED_DATA_STORAGE_KEY = "ragchat_extracted_data";

export interface ExtractedDataItem {
  chunkIndex: number;
  data: unknown;
  timestamp: number;
  extractionName: string;
}

export const saveExtractedData = (chunkIndex: number, data: unknown, extractionName: string = "extract_data"): void => {
  try {
    const existingData = getAllSavedExtractedData();

    const newDataItem: ExtractedDataItem = {
      chunkIndex,
      data,
      timestamp: Date.now(),
      extractionName
    };

    const updatedData = existingData.filter(item => item.chunkIndex !== chunkIndex);
    updatedData.push(newDataItem);

    updatedData.sort((a, b) => a.chunkIndex - b.chunkIndex);

    localStorage.setItem(EXTRACTED_DATA_STORAGE_KEY, JSON.stringify(updatedData));
    console.log(`Saved extracted data for chunk ${chunkIndex}:`, data);
  } catch (error) {
    logError("Failed to save extracted data", error);
  }
};

export const getAllSavedExtractedData = (): ExtractedDataItem[] => {
  try {
    const storedData = localStorage.getItem(EXTRACTED_DATA_STORAGE_KEY);
    if (!storedData) {
      return [];
    }

    const parsedData = JSON.parse(storedData);
    return Array.isArray(parsedData) ? parsedData : [];
  } catch (error) {
    logError("Failed to retrieve extracted data", error);
    return [];
  }
};

export const getExtractedDataForChunk = (chunkIndex: number): ExtractedDataItem | null => {
  const allData = getAllSavedExtractedData();
  return allData.find(item => item.chunkIndex === chunkIndex) || null;
};

export const clearAllSavedExtractedData = (): void => {
  try {
    localStorage.removeItem(EXTRACTED_DATA_STORAGE_KEY);
    console.log("Cleared all saved extracted data");
  } catch (error) {
    logError("Failed to clear extracted data", error);
  }
};

export const getSavedExtractedDataCount = (): number => {
  return getAllSavedExtractedData().length;
};

export const getExtractedDataForSynthesis = (): unknown[] => {
  const allData = getAllSavedExtractedData();
  return allData.map(item => item.data);
};
